export default __webpack_public_path__ + "static/case-2-18215f497a35c16bd9893c35b82ff7dd.png";